import React from 'react'

export default function Empty() {
  return (
    <section className="performance-table__empty">
      <h2>Start by selecting a factor or category</h2>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/factors/historical/empty.js